import { Alert, Typography } from "antd";
import ImageWithDescription from "../../Components/ImageWithDescription";

const { Title } = Typography;

export const UpdateManual = () => {
  return (
    <div style={{ maxWidth: 900, background: "#ffffff0d", padding: 30 }}>
      <Title>Update instructions</Title>
      <Alert
        type="warning"
        showIcon
        message="We recommend waiting before updating until you have enough time to test the update in case there are any unexpected issues."
      />
      <ol>
        <li>
          <Title level={3}>Launcher Update</Title>
          <p>
            You should see a popup in the launcher when a new version is
            available. If you have update notifications disabled, you can also
            check for updates manually: Navigate to the About page in the
            settings and click on Check for updates.
          </p>
          <p>Click on Update.</p>
          <ImageWithDescription
            width={600}
            src="/images/manual/Update/LauncherUpdate1.jpg"
            description="Launcher Update"
          />
        </li>
        <li>
          <Title level={3}>Download Game Update</Title>
          <p>
            Click on the update games button in the launcher settings (may be
            "download games" instead)
          </p>
          <ImageWithDescription
            width={600}
            src="/images/manual/Update/DownloadGames1.jpg"
            description="Download Games"
          />
          <ImageWithDescription
            width={600}
            src="/images/manual/Update/DownloadGames2.jpg"
            description="Start Download"
          />
          <Alert
            type="warning"
            showIcon
            message="Make sure your headset type is selected and the desired version is set to latest"
          />
          <br />
          <p>Click on Start Download.</p>

          <p>
            When the download is complete, it will ask you to install the update
            on your headsets.
          </p>
        </li>
        <li>
          <Title level={3}>Install Game Update</Title>
          <p>Click on Install Games in the launcher settings</p>
          <ImageWithDescription
            width={600}
            src="/images/manual/Update/installGames1.jpg"
            description="Install Games"
          />
          <p>
            Connect one or more headsets with USB cables and click on install
          </p>
        </li>
      </ol>
      <p>
        The update should now be complete. We recommend testing the update
        before offering it to your customers.
      </p>
      <div style={{ height: 100 }} />
    </div>
  );
};
